var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-sm btn-outline-primary mx-1",on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }